export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const formatInstagramUrl = (instagram: string): string => {
  if (!instagram) return '';

  if (instagram.startsWith('http://') || instagram.startsWith('https://')) {
    if (isValidUrl(instagram)) {
      if (instagram.includes('instagram.com') || instagram.includes('instagr.am')) {
        return instagram;
      }
      return '';
    }
    const handle = instagram.replace(/^https?:\/\//, '').replace(/^@/, '');
    return `https://instagram.com/${handle}`;
  }

  const handle = instagram.replace(/^@/, '').trim();
  if (handle && /^[a-zA-Z0-9._]+$/.test(handle)) {
    return `https://instagram.com/${handle}`;
  }

  return '';
};

export const formatYouTubeUrl = (youtube: string): string => {
  if (!youtube) return '';

  if (youtube.startsWith('http://') || youtube.startsWith('https://')) {
    if (isValidUrl(youtube)) {
      if (youtube.includes('youtube.com') || youtube.includes('youtu.be')) {
        return youtube;
      }
      return '';
    }
    const channelName = youtube.replace(/^https?:\/\//, '').replace(/^@/, '');
    return `https://youtube.com/@${channelName}`;
  }

  const channelName = youtube.replace(/^@/, '').trim();
  if (channelName && /^[a-zA-Z0-9._-]+$/.test(channelName)) {
    return `https://youtube.com/@${channelName}`;
  }

  return '';
};
